import { render, staticRenderFns } from "./MessagesSecurity.vue?vue&type=template&id=78997eb2&scoped=true"
import script from "./MessagesSecurity.vue?vue&type=script&lang=js"
export * from "./MessagesSecurity.vue?vue&type=script&lang=js"
import style0 from "./MessagesSecurity.vue?vue&type=style&index=0&id=78997eb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78997eb2",
  null
  
)

export default component.exports